import { CountryIconProps } from './types';

const NO = ({ dimension }: CountryIconProps) => (
  <svg
    width={dimension || 24}
    height={dimension || 24}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_1046_3746)">
      <path
        d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z"
        fill="#F0F0F0"
      />
      <path
        d="M0.413086 15.131C1.1074 17.7072 2.63763 19.94 4.69535 21.5211V15.131H0.413086Z"
        fill="#D80027"
      />
      <path
        d="M10.9561 23.9549C11.3 23.9845 11.6479 24.0005 11.9995 24.0005C17.5439 24.0005 22.2091 20.2402 23.5861 15.131H10.9561V23.9549Z"
        fill="#D80027"
      />
      <path
        d="M23.5861 8.87004C22.2091 3.76085 17.5439 0.000488281 11.9995 0.000488281C11.6479 0.000488281 11.3 0.0165195 10.9561 0.0461445V8.87004H23.5861Z"
        fill="#D80027"
      />
      <path
        d="M4.69535 2.48029C2.63763 4.06138 1.1074 6.29418 0.413086 8.87038H4.69535V2.48029Z"
        fill="#D80027"
      />
      <path
        d="M23.8984 10.4343H9.39136H9.39131V0.284729C8.28234 0.530635 7.23098 0.929213 6.26086 1.45857V10.4342V10.4342H0.101578C0.0347813 10.9466 0 11.469 0 11.9995C0 12.53 0.0347813 13.0524 0.101578 13.5647H6.26081H6.26086V22.5404C7.23098 23.0697 8.28234 23.4684 9.39131 23.7142V13.5648V13.5647H23.8984C23.9651 13.0524 24 12.53 24 11.9995C24 11.469 23.9651 10.9466 23.8984 10.4343Z"
        fill="#0052B4"
      />
    </g>
    <defs>
      <clipPath id="clip0_1046_3746">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export default NO;
